import { render } from "./ButtonRouter.vue?vue&type=template&id=4e47d2e8"
import script from "./ButtonRouter.vue?vue&type=script&lang=js"
export * from "./ButtonRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__